import { AxiosBaseQueryFunction } from 'api/axiosBaseQuery';

import { WaterfallLabor } from '@common/models';
import { useFetchDependencies } from '@core/hooks/useFetchDependencies';
import { useSelectedColor } from '@ee-api/colors-api/useSelectedColor';
import { CommonProductQueryParams } from '@ee-api/queryParams';
import { useSelectedStore } from '@ee-api/stores-api/useSelectedStore';
import { useAppSelector } from '@redux/hooks';
import { selectZipcode } from '@redux/slices/zipcodeSlice';
import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';
import { skipToken } from '@reduxjs/toolkit/query';

import { useGetWaterfallLaborFeeQuery } from './waterfalLaborService';

type UseWaterfallLaborReturn = TypedUseQueryHookResult<
    WaterfallLabor,
    CommonProductQueryParams,
    AxiosBaseQueryFunction
> & {
    waterfallLaborFee?: WaterfallLabor;
    isFetchingWaterfallLaborFee: boolean;
    isErrorWaterfallLaborFee: boolean;
};

export const useWaterfallLabor = (): UseWaterfallLaborReturn => {
    const zipCode = useAppSelector(selectZipcode);
    const { selectedValue: selectedStore } = useSelectedStore();
    const { selectedValue: selectedColor } = useSelectedColor();
    const { isFetchingDependencies } = useFetchDependencies();

    const { waterfallLaborFee, ...rest } = useGetWaterfallLaborFeeQuery(
        !isFetchingDependencies && zipCode && selectedStore?.companyId && selectedColor?.qteGrpID
            ? {
                  params: {
                      zipCode,
                      storeId: selectedStore?.companyId,
                      prodQteGrpID: selectedColor?.qteGrpID ?? undefined,
                  },
              }
            : skipToken,
        { selectFromResult: (result) => ({ waterfallLaborFee: result.isError ? undefined : result.data, ...result }) }
    );

    return {
        waterfallLaborFee,
        isFetchingWaterfallLaborFee: rest.isFetching,
        isErrorWaterfallLaborFee: rest.isError,
        ...rest,
    };
};
